// extracted by mini-css-extract-plugin
module.exports = {"input":"Shipping_input__3sMuY","button":"Shipping_button__20l5_"};